import { Reducer } from "redux"
import { Action } from "../types"

interface TransactionsState {
  transactions: any[]
  selectedTransaction: any
}

const initialState: TransactionsState = {
  transactions: [],
  selectedTransaction: {},
}

const transactionReducer: Reducer<TransactionsState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case "SET_TRANSACTIONS":
      return {
        ...state,
        transactions: action.payload,
      }
    case "SET_SELECTED_TRANSACTION":
      return {
        ...state,
        selectedTransaction: action.payload,
      }
    case "REMOVE_SELECTED_TRANSACTION":
      return {
        ...state,
        selectedTransaction: {},
      }
    default:
      return state
  }
}

export { transactionReducer }
